import { IconClockFilled } from '@iwoca/icons';
import { t } from '@lingui/macro';
import { ICellRendererParams } from 'ag-grid-community';

import { differenceInCalendarDays } from 'date-fns';
import { useLocale } from 'hooks/useLocale';
import { APPLICATION_STATUS } from 'utils/applications/applications.config';
import styles from './OfferExpiryDateCell.module.css';

export const OfferExpiryDateCell = ({
  value,
  data,
}: Pick<ICellRendererParams, 'value' | 'data'>) => {
  const { i18n } = useLocale();
  const applicationStatus = data?.status;

  const todaysDate = new Date().toISOString().split('T')[0]; // 'yyyy-MM-dd'
  const expiryDate = value ? value : null;

  const daysTilExpiry =
    expiryDate &&
    differenceInCalendarDays(new Date(expiryDate), new Date(todaysDate));

  const showExpiryDate =
    applicationStatus === APPLICATION_STATUS.offered ||
    applicationStatus === APPLICATION_STATUS.conditional_offer ||
    applicationStatus === APPLICATION_STATUS.talking_to_customer;

  const showExpiringSoon =
    daysTilExpiry !== null &&
    daysTilExpiry !== '' &&
    daysTilExpiry >= 0 &&
    daysTilExpiry <= 5 &&
    showExpiryDate;

  const renderExpiryMessage = (amountOfDays: number | null) => {
    if (amountOfDays === 0) {
      return t`Expires today`;
    }
    if (amountOfDays === 1) {
      return t`Expires tomorrow`;
    }
    return t`Expires in ${amountOfDays} days`;
  };

  const renderFormattedDate = (date: string) =>
    i18n.date(date, {
      day: '2-digit',
      month: 'short',
      year: '2-digit',
    });

  const renderExpiryDate = (expiryDate: string) => {
    if (showExpiringSoon) {
      return (
        <div className={styles.expiringContainer}>
          <IconClockFilled className={styles.icon} />
          <div className={styles.expiringMessages}>
            <p>{renderExpiryMessage(daysTilExpiry)}</p>
            <p>({renderFormattedDate(expiryDate)})</p>
          </div>
        </div>
      );
    }
    return <p>{renderFormattedDate(expiryDate)}</p>;
  };

  return (
    <div className={styles.expiringContainer} data-testid="expiring-dates">
      {expiryDate && showExpiryDate ? renderExpiryDate(expiryDate) : '-'}
    </div>
  );
};
